"use strict";

var TokenLogin = {
  getSchema: function getSchema() {
    return {
      "properties": {
        "phoneNumber": { "type": "string" }
      },
      "required": ["phoneNumber"]
    };
  },

  execute: function execute(fbApp, body, timestamp, callback) {
    // Create Custom token
    fbApp.auth().createCustomToken(body.phoneNumber).then(function (customToken) {
      // Send token back to client
      console.log('SUCCESS');
      callback(null, {
        token: customToken
      });
    }).catch(function (error) {
      console.log('ERROR from Firebase');
      console.log(JSON.stringify(error));
      callback(error);
    });
  }
};

module.exports = TokenLogin;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/functions/TokenLogin.js
// module id = 1028
// module chunks = 0